export const authApiEndpoints = {
  login: `/auth/login`,
};
